import { LOGGING_OUT, LOGGING_OUT_SUCCESS, LOGIN_ATTEMP, LOGIN_ATTEMP_ERROR, LOGIN_ATTEMP_SUCCESS } from "../action/loginAction";


let initialState = {
    loading:false,
    error: "",
    user:{},
    loggingOut:false
}


export default function userReducer(state = initialState,action){
    switch(action.type){
        case LOGIN_ATTEMP:
            return {...state, loading: true}
        case LOGIN_ATTEMP_ERROR:
            return {...state, loading: false, error: action.payload}
        case LOGIN_ATTEMP_SUCCESS:
            return {...state, loading: false, user: action.payload}
        case LOGGING_OUT:
            return {...state, loggingOut:true}
        case LOGGING_OUT_SUCCESS:
            return {...state, loggingOut:false}
        default:
            return state;
    }
}